export const PromotionHubEntryEventLabels = {
    sideMenu: 'side_menu',
    accountPage: 'account_page',
    topBar: 'top_bar',
    purpleSport: 'purple_sport',
    purpleCasino: 'purple_casino',
    purpleNews: 'purple_news',
    quickLinks: 'quick_links',
    accountPageHeader: 'account_page_header',
    accountSideMenu: 'account_side_menu',
} as const;
export type PromotionHubEntryEventLabels = typeof PromotionHubEntryEventLabels[keyof typeof PromotionHubEntryEventLabels];
